import type { SupportAdoption } from '@siteday/shared';

import type { PillTone } from '@/components/ui/badge';

export interface AdoptionPill {
  tone: PillTone;
  label: string;
  /** One line for the tooltip / detail header. */
  hint: string;
}

/**
 * Adoption state → pill (doc 13 "Monitoring and alerts", the adoption number).
 * `alerted` is the "went quiet" alert Fuorix should act on this week; `quiet`
 * is silent without the alert firing (e.g. never crossed the 14-day window).
 */
export function adoptionPill(state: SupportAdoption): AdoptionPill {
  switch (state) {
    case 'active':
      return { tone: 'good', label: 'Active', hint: 'Submitted an entry in the last 7 days' };
    case 'alerted':
      return { tone: 'bad', label: 'Went quiet', hint: 'Had entries in the prior 14 days and none on the last 3 working days — call them' };
    case 'quiet':
      return { tone: 'warn', label: 'Quiet', hint: 'No entry in the last 7 days' };
    case 'new':
      return { tone: 'info', label: 'New', hint: 'No entry submitted yet' };
  }
}

/** Sort weight: the companies needing attention first. */
export function adoptionRank(state: SupportAdoption): number {
  return { alerted: 0, quiet: 1, new: 2, active: 3 }[state];
}
